import { type ReactElement } from 'react'

import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/**
 * Pending placeholder for the account screen — mirrors the real page frame (title + the two
 * always-present info sections) so the crossfade into `AccountPage` has no layout shift.
 */
// A row is 72px: `py-50` (16px top and bottom) plus a 40px content column (two 18px lines and the
// 4px gap between them), which is taller than the 32px icon media beside it.
const ROW_HEIGHT_PX = 72
const ACCOUNT_INFO_ROW_COUNT = 3 // first name, last name, address
const CONTACT_INFO_ROW_COUNT = 2 // email, phone

export function AccountPageSkeleton(): ReactElement {
  return (
    <LoadingRegion label="Chargement">
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={200} height={32} />
        </View.Header>
        <View.Body>
          <div className="flex flex-col gap-stack">
            <Skeleton variant="text" width={220} height={24} />
            <Skeleton variant="block" height={ROW_HEIGHT_PX * ACCOUNT_INFO_ROW_COUNT} />
          </div>
          <div className="flex flex-col gap-stack">
            <Skeleton variant="text" width={220} height={24} />
            <Skeleton variant="block" height={ROW_HEIGHT_PX * CONTACT_INFO_ROW_COUNT} />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
